import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["html", "subject", "attachments"];
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _padStartInstanceProperty from "@babel/runtime-corejs3/core-js/instance/pad-start";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js/instance/starts-with";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import VueSimpleSuggest from "vue-simple-suggest";
import ConfirmLoadEmailTemplateModal from "./confirm-load-email-template";
import Err from "../../../../../../routes/error";
import { mapActions, mapGetters, mapState } from "vuex";
import { SEND_EMAIL_TO_CLIENT, LOAD_BOARD_COLLABORATORS } from "@Broker/@Modules/clients/board/store/board-actions";
import { timeBombTooltip } from "../../../../../../custom/utils";
import EmailEditorTemplates from "../../../../../util-components/on-demand-email-templates/email-editor-templates";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import MaterialInput from "@Shared/components/inputs/material-input";
import DateSection from "@Shared/components/sections/date-section.vue";
import Field from "@Shared/components/sections/field.vue";
import { requiredHTML, multipleEmail, softValidate } from "@Shared/@Utils/validation-rules";
import EmailEditor from "@Shared/components/inputs/email-editor";
import { delay } from "@Shared/utils/utils";
import vuelidateMixin from "@Shared/utils/shared-mixins/vuelidate-valid-mixin";
import SelectEmailField from "./email-tab/select-email-field";
import { showToast } from "@Shared/@Utils/constants";
import IncidentMessage from "@Broker/@Modules/status-page/components/incident-message.vue";
import { CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_TAGS, GET_EMAIL_TEMPLATES, COLLABORATORS, BOARD_OWNER_BY_BOARD_ID, GET_PROFILE_PARTICIPANTS } from "@Broker/@Modules/clients/board/store/board-getters";
import { ACCOUNT_EMAIL_SIGNATURE } from "@Broker/@Modules/main/store/account/account-getters";
import { ACCOUNT_HAS_EMAIL_SYNCED } from "@Broker/@Modules/settings/store/settings-getters";
import { isEmpty } from "lodash";
import GenerateAiEmailModal from "@Broker/@Modules/clients/applications/application/components/header-components/generate-ai-email-modal.vue";
import VueTimepicker from "vue2-timepicker";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmailTab",
  components: {
    EmailEditorTemplates,
    MaterialInput,
    EmailEditor,
    SelectEmailField,
    IncidentMessage,
    VueSimpleSuggest,
    ConfirmLoadEmailTemplateModal,
    GenerateAiEmailModal,
    VueTimepicker,
    DateSection,
    Field
  },
  mixins: [validationMixin, vuelidateMixin],
  props: {
    tabData: {
      type: Object,
      default: () => ({})
    },
    profile: {
      type: Object,
      required: true
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    currentTab: {
      type: String,
      required: true
    },
    external: {
      type: Boolean,
      default: false
    },
    boardId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    const tabData = this.initData();
    return {
      generatedEmailBody: "",
      nylasDisabled: false,
      showEditor: true,
      loading: true,
      loadedTemplate: {},
      saveAsNew: false,
      createWithActivity: false,
      email: _objectSpread(_objectSpread({
        messageId: null,
        html: this.ACCOUNT_EMAIL_SIGNATURE ? `<div><br> -- <br> ${this.ACCOUNT_EMAIL_SIGNATURE}</div>` : "",
        ccList: [],
        bccList: []
      }, tabData), {}, {
        subject: this.tabData.subject ? `Re: ${this.tabData.subject}` : "",
        toList: "",
        scheduleDelivery: false,
        scheduledDate: null,
        scheduledTime: {
          A: "",
          hh: "",
          mm: ""
        }
      }),
      editor: null,
      emailAttachments: [],
      autocompleteStyles: {
        vueSimpleSuggest: "simple-autocomplete",
        suggestItem: "simple-autocomplete-suggest-item"
      },
      templateDataForConfirmation: {}
    };
  },
  validations: {
    email: {
      html: {
        requiredHTML
      },
      toList: {
        required,
        multipleEmail
      },
      ccList: {
        multipleEmail
      },
      bccList: {
        multipleEmail
      },
      subject: {
        required: softValidate(required)
      }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [GET_EMAIL_TEMPLATES, CLIENT_PROFILE_CUSTOM_FIELDS_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS, COLLABORATORS, BOARD_OWNER_BY_BOARD_ID, GET_PROFILE_PARTICIPANTS])), mapState("BoardStore", {
    emailTemplatesById(state) {
      return state.emailTemplates.byId || {};
    }
  })), mapGetters("AccountStore", [ACCOUNT_EMAIL_SIGNATURE])), mapGetters("SettingsStore", [ACCOUNT_HAS_EMAIL_SYNCED])), {}, {
    coApplicants() {
      return this.profile.coApplicants;
    },
    isValidClientEmail() {
      return !isEmpty(this.profile.email) && email(this.profile.email);
    },
    disableSubmit() {
      return this.nylasDisabled || !this.isValidWithWarnings;
    },
    emailTemplates() {
      return this.GET_EMAIL_TEMPLATES;
    },
    emailTemplatesWithSubject() {
      var _context;
      return _filterInstanceProperty(_context = this.emailTemplates).call(_context, template => !isEmpty(template.subject));
    },
    customFieldsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_TAGS(this.clientProfileId);
    },
    customFieldsHintsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS(this.clientProfileId);
    },
    collaborators() {
      var _this$boardId;
      return _Object$values(this.COLLABORATORS((_this$boardId = this.boardId) != null ? _this$boardId : this.profile.boardId));
    },
    boardOwner() {
      var _this$boardId2;
      return this.BOARD_OWNER_BY_BOARD_ID((_this$boardId2 = this.boardId) != null ? _this$boardId2 : this.profile.boardId);
    },
    hasCoApplicants() {
      return this.coApplicants && this.coApplicants.some(({
        email
      }) => email);
    },
    toListDefaultValue() {
      return this.hasCoApplicants ? [this.profile.email] : this.profile.email;
    },
    allApplicants() {
      return [this.profile, ...this.coApplicants];
    },
    participantEmails() {
      var _context2;
      return _mapInstanceProperty(_context2 = this.GET_PROFILE_PARTICIPANTS(this.clientProfileId)).call(_context2, p => ({
        email: p.email,
        givenName: p.firstName,
        familyName: p.lastName
      }));
    },
    participantsForMergeTags() {
      return this.GET_PROFILE_PARTICIPANTS(this.clientProfileId);
    },
    hasParticipants() {
      return this.participantEmails && this.participantEmails.length > 0;
    },
    ccListOptions() {
      var _context3;
      return _filterInstanceProperty(_context3 = [...this.collaborators, ...this.allApplicants, ...this.participantEmails, this.boardOwner]).call(_context3, o => o);
    },
    bccListOptions() {
      return [...this.collaborators, ...this.allApplicants, ...this.participantEmails];
    },
    finalToList() {
      return [...this.allApplicants, ...this.participantEmails];
    }
  }),
  watch: {
    tabData(val) {
      var _context4, _context5;
      this.email = _objectSpread(_objectSpread(_objectSpread({}, this.email), val), {}, {
        toList: this.toListDefaultValue,
        ccList: val.action === "all" ? _mapInstanceProperty(_context4 = val.ccList.list).call(_context4, ({
          email
        }) => email) : [],
        bccList: val.action === "all" ? _mapInstanceProperty(_context5 = val.bccList.list).call(_context5, ({
          email
        }) => email) : [],
        subject: val.subject ? `Re: ${val.subject}` : ""
      });
      this.$nextTick(() => {
        if (this.currentTab === "email") {
          this.$refs.emailEditor.focusIn();
        }
      });
    },
    profile: {
      deep: true,
      handler(newVal) {
        var _context6;
        if (!_includesInstanceProperty(_context6 = this.email.toList).call(_context6, newVal.email)) {
          this.email.toList = this.toListDefaultValue;
        }
      }
    },
    isValidClientEmail(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.showEditor = false;
      }
    }
  },
  mounted() {
    this.$nextTick(async () => {
      var _this$boardId3;
      await this.LOAD_BOARD_COLLABORATORS({
        boardId: (_this$boardId3 = this.boardId) != null ? _this$boardId3 : this.profile.boardId
      });
      this.initEmail(this.tabData);
      this.loading = false;
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [SEND_EMAIL_TO_CLIENT, LOAD_BOARD_COLLABORATORS])), {}, {
    reloadEditor() {
      this.showEditor = true;
    },
    async delay(val) {
      return await delay(val);
    },
    handleEditorChange({
      content
    }) {
      this.email.html = content;
      this.$v.email.$touch();
    },
    initData() {
      var _context7;
      if (!isEmpty(this.tabData)) return {};
      return _objectSpread(_objectSpread({}, this.tabData), {}, {
        ccList: this.tabData.action === "all" ? _mapInstanceProperty(_context7 = this.tabData.ccList.list).call(_context7, ({
          email
        }) => email) : [],
        bccList: []
      });
    },
    async handleSubmit() {
      if (this.disableSubmit) return;
      const submitButton = $(this.$refs.submitEmail);
      try {
        submitButton.animateButton().animate("start");

        // Calculate sendAt timestamp if scheduling is enabled
        let sendAt = null;
        if (this.email.scheduleDelivery && this.email.scheduledDate && this.email.scheduledTime) {
          var _context8, _context9;
          // Get values from the scheduledTime object (always in format {A:"PM", hh:"03", mm:"18"})
          const hours12 = _parseInt(this.email.scheduledTime.hh);
          const minutes = this.email.scheduledTime.mm;
          const isPM = this.email.scheduledTime.A.toUpperCase() === "PM";

          // Convert 12-hour to 24-hour format
          let hours24 = hours12;
          if (isPM && hours12 < 12) hours24 += 12;
          if (!isPM && hours12 === 12) hours24 = 0;

          // Format time string for the Date constructor
          const timeString = `${_padStartInstanceProperty(_context8 = String(hours24)).call(_context8, 2, "0")}:${_padStartInstanceProperty(_context9 = String(minutes)).call(_context9, 2, "0")}`;
          const dateTimeString = `${this.email.scheduledDate}T${timeString}`;
          const scheduledTime = new Date(dateTimeString);
          const now = new Date();
          const maxDate = new Date();
          maxDate.setDate(maxDate.getDate() + 29); // 29 days from now

          // Validate that the scheduled time is in the future
          if (scheduledTime <= now) {
            showToast("error", "scheduledTimeInFuture");
            submitButton.animateButton().animate("finish", "failed");
            return;
          }

          // Validate that the scheduled time is not more than 29 days in the future
          if (scheduledTime > maxDate) {
            showToast("error", "emailScheduleLimit29Days");
            submitButton.animateButton().animate("finish", "failed");
            return;
          }
          sendAt = Math.floor(scheduledTime.getTime() / 1000); // Convert to unix timestamp (seconds)
        }
        const emailId = await this.SEND_EMAIL_TO_CLIENT({
          id: this.clientProfileId,
          data: _objectSpread(_objectSpread({}, this.email), {}, {
            body: this.$refs.emailEditor.getHTML() || "",
            subject: this.email.subject || "",
            cc: this.email.ccList,
            bcc: this.email.bccList,
            attachments: this.emailAttachments,
            sendAt
          }),
          email: this.profile.email
        });
        if (sendAt) {
          showToast("success", "emailScheduled");
        } else {
          showToast("success", "emailSent");
        }
        Amplitude.updateCount("emails sent");
        Amplitude.logEvent("Board - email sent", {
          page: "clients-board",
          clientProfileId: this.clientProfileId,
          attachments: this.emailAttachments
        });
        this.email = {
          toList: this.toListDefaultValue,
          scheduleDelivery: false,
          scheduledDate: null,
          scheduledTime: {
            A: "",
            hh: "",
            mm: ""
          },
          messageId: null,
          html: this.ACCOUNT_EMAIL_SIGNATURE ? `<div><br> -- <br> ${this.ACCOUNT_EMAIL_SIGNATURE}</div>` : "",
          ccList: [],
          bccList: [],
          subject: ""
        };
        this.clearTemplate();
        this.$refs.templatesToolbar.clearTemplate();
        this.emailAttachments = [];
        if (this.createWithActivity) {
          showBModal("activity-convert-modal", {
            id: emailId,
            activityType: "email"
          }, this);
          this.$nextTick(() => {
            this.createWithActivity = false;
          });
        }
        this.$emit("clear-data");
        await submitButton.animateButton().animate("finish");
        submitButton.removeClass("form-finish");
        this.email.html = "";
        this.generatedEmailBody = "";
      } catch (e) {
        Err.handle(e);
        submitButton.animateButton().animate("finish", "failed");
      }
    },
    clearTemplate() {
      this.$refs.emailEditor.clearTemplate();
      this.email.subject = "";
    },
    handleTemplateSelect(_ref) {
      let {
          html,
          subject,
          attachments
        } = _ref,
        data = _objectWithoutProperties(_ref, _excluded);
      try {
        this.$refs.emailEditor.setHtml(html);
        this.$refs.emailEditor.setAttachments(attachments || []);
        if (!isEmpty(subject)) this.email.subject = subject;
        this.$refs.templateAutocomplete.hideList();
        this.loadedTemplate = _objectSpread({
          html,
          subject,
          attachments
        }, data);
      } catch (e) {
        Err.handle(e);
      }
    },
    handleSendEmail(createWithActivity) {
      this.createWithActivity = createWithActivity;
      this.handleSubmit();
      if (!createWithActivity) {
        this.showAddTooltip();
      }
    },
    async showAddTooltip() {
      const target = $(this.$refs.addTipTooltip);
      timeBombTooltip(target, {
        placement: "bottom",
        trigger: "manual"
      });
    },
    initEmail(val) {
      var _context0, _context1;
      this.email = _objectSpread(_objectSpread(_objectSpread({}, this.email), val), {}, {
        toList: this.toListDefaultValue,
        ccList: val.action === "all" ? _mapInstanceProperty(_context0 = val.ccList.list).call(_context0, ({
          email
        }) => email) : [],
        bccList: val.action === "all" ? _mapInstanceProperty(_context1 = val.bccList.list).call(_context1, ({
          email
        }) => email) : [],
        subject: val.subject ? `Re: ${val.subject}` : "",
        scheduleDelivery: false,
        scheduledDate: null,
        scheduledTime: {
          A: "",
          hh: "",
          mm: ""
        }
      });
      this.createWithActivity = false;
    },
    handleSubmitClick() {
      if (!this.external) return;
      this.handleSubmit();
    },
    handleAttachmentChange({
      attachments
    }) {
      this.emailAttachments = attachments;
    },
    showAutoComposeModal() {
      this.$refs.generateEmailModal.openModal();
    },
    redirectToSettings() {
      window.location = "#/personal-settings/account/email-preferences";
    },
    handleIncidentUpdate(hasIncident) {
      this.nylasDisabled = hasIncident;
    },
    async handleSelectTemplateAutocomplete() {
      this.email.subject = this.templateDataForConfirmation.subject;
      this.emailAttachments = this.templateDataForConfirmation.attachments;
      this.loadedTemplate = this.emailTemplatesById[this.templateDataForConfirmation.id];
      this.$refs.templatesToolbar.handleTemplateSelect(this.loadedTemplate.id);
      this.$refs.confirmLoadTemplate.$hideModal();
    },
    openConfirmLoadTemplate({
      id,
      subject
    }) {
      this.templateDataForConfirmation = {
        id,
        subject
      };
      this.$refs.confirmLoadTemplate.$showModal();
    },
    emailTemplateSearch(template, searchQuery) {
      var _context10;
      return _startsWithInstanceProperty(_context10 = template.subject.toLowerCase()).call(_context10, searchQuery.toLowerCase());
    },
    handleCancelTemplateConfirmationModal() {
      this.$refs.templateAutocomplete.research();
    },
    handleHideTemplateConfirmationModal() {
      this.templateDataForConfirmation = {};
    },
    handleSaveGeneratedEmail(body, subject) {
      this.generatedEmailBody = body;
      this.email.subject = subject;
    },
    handleScheduledDateChange(value) {
      // Check if the selected date is more than 29 days in the future
      if (value) {
        const selectedDate = new Date(value);
        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 29); // 29 days from now

        if (selectedDate > maxDate) {
          showToast("error", "Emails can only be scheduled up to 29 days in the future");
          // Reset to max allowed date
          this.email.scheduledDate = maxDate.toISOString().split("T")[0];
          return;
        }
      }
      this.email.scheduledDate = value;
    },
    handleScheduleDeliveryChange(event) {
      // If the checkbox is unchecked, reset the date and time values
      if (!event.target.checked) {
        this.email.scheduledDate = null;
        this.email.scheduledTime = {
          A: "",
          hh: "",
          mm: ""
        };
      } else {
        var _context11, _context12;
        // Set default values: current date and current time + 5 minutes
        const now = new Date();

        // Set current date in YYYY-MM-DD format
        this.email.scheduledDate = now.toISOString().split("T")[0];

        // Add 5 minutes to current time
        now.setMinutes(now.getMinutes() + 5);

        // Format time in 12-hour format with AM/PM
        const hours = now.getHours();
        const minutes = _padStartInstanceProperty(_context11 = String(now.getMinutes())).call(_context11, 2, "0");
        const period = hours >= 12 ? "PM" : "AM";
        const hours12 = _padStartInstanceProperty(_context12 = String(hours % 12 || 12)).call(_context12, 2, "0");

        // Set the scheduledTime in the expected object format for 12-hour time
        this.email.scheduledTime = {
          A: period,
          hh: hours12,
          mm: minutes
        };
      }
    },
    getMaxFutureDate() {
      // Calculate max date (29 days from now)
      const maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + 29);
      return maxDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    }
  })
});